<script setup>
import { ref, defineProps, onMounted, reactive, watch } from "vue";
import ElevateESFEventDetail from "./ElevateESFEventDetail.vue";

const props = defineProps({
  events: Array,
});

const changes = reactive([]);
const eventTypes = ["Profile:Add", "Profile:Remove"];

onMounted(() => {
  if (props.events?.length > 0) {
    props.events.forEach((event) => {
      if (eventTypes.includes(event.eventtype)) {
        changes.push(event);
      }
    });
  }
});

const headers = [
  { text: "Action", value: "eventtype" },
  { text: "Profile", value: "target" },
];

const searchValue = ref("");
function searchFields() {
  return headers.map((header) => header.value);
}
</script>

<template>
  <EasyDataTable
    :items="changes"
    :headers="headers"
    :search-fields="searchFields()"
    :search-value="searchValue"
    theme-color="#e7541e"
    empty-message="No Configuration Changes Recorded"
  >
    <template #expand="item">
      <ElevateESFEventDetail :event="item.event" />
    </template>
  </EasyDataTable>
</template>
